import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { isDOMReady, modalRoot } from './helpers';
import cx from 'classnames';

import './Modal.scss';

const Modal = props => {
  if (props.bypass) {
    return props.children;
  }
  if (!isDOMReady() || !props.isOpen) {
    return null;
  }
  return ReactDOM.createPortal(
    <div
      className={cx('modal', {
        'modal--open': props.isOpen,
        'modal--default': props.default,
        [props.className]: !!props.className
      })}
      style={props.style}>
      {props.children}
    </div>,
    modalRoot,
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  bypass: PropTypes.bool,
  default: PropTypes.bool,
  style: PropTypes.object,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Modal/Modal.js